module.exports = __webpack_public_path__ + "static/samurai-56f4162ae04a005b79fc3eecf37a75cc.png";